import { post } from '@/api/request'

export default {

  addToWorkflow: (data, success, failure) => post(
    '/api/workflow/task',
    data,
    response => success(response),
    error => failure(error)
  ),
  
  removeTask: (taskId, success, failure) => post(
    `/api/workflow/${taskId}/remove`,
    {},
    response => success(response),
    error => failure(error)
  ),

  updateSlotTime: (payload, success, failure) => post(
    `/api/workflow/${payload.taskId}/time`,
    payload,
    response => success(response),
    error => failure(error)
  ),
  
  saveColor: (payload, success, failure) => post(
    `/api/workflow/${payload.taskId}/color`,
    payload,
    response => success(response),
    error => failure(error)
  ),

}